import { render, staticRenderFns } from "./CommonTableColumn.vue?vue&type=template&id=443dbfc8&scoped=true&"
import script from "./CommonTableColumn.vue?vue&type=script&lang=js&"
export * from "./CommonTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443dbfc8",
  null
  
)

export default component.exports